module.exports = __webpack_public_path__ + "media/img/android-icon-96x96-3763a89c7fcd27ecf0004aaef124e78e.png";